import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import * as _ from 'lodash';
import { CREATE_REGION, UPDATE_REGION } from 'actions/address';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';

const RegionForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();

  const regionDetail = useSelector((state) => state.region.regionDetail);
  const isLoading = useSelector((state) => state.region.isLoading);

  const addRegion = useCallback((data) => {
    dispatch({
      type: CREATE_REGION.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateRegion = useCallback((data) => {
    dispatch({
      type: UPDATE_REGION.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const RegionSchema = Yup.object().shape({
    name: Yup.string()
      .required('Region Name is required')
      .strict(true)
      .trim('Space not allowed')
      .max(100, 'Max limit reached'),
  });

  const initialValues = isEdit
    ? { ...regionDetail }
    : {
        name: '',
      };

  return (
    <React.Fragment>
      <div className="country-form-page__main">
        <Card>
          <div className="country-form-header__block">
            <div className="country-header-name">
              <span>
                {isEdit ? 'Edit' : 'Add'} Region
              </span>
            </div>
            <div className="close-btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
          </div>
          <div className="country-form-body__block">
            <div className="country-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={RegionSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    updateRegion(values);
                  } else {
                    addRegion(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg={12}>
                        <TextInput
                          isRequired
                          label="Region Name"
                          placeholder="Region Name"
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn-block">
                      <Button className="country-form-btn cancel_btn" onClick={onClose}>
                        Cancel
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="country-form-btn create-btn">
                        {isEdit ? 'Update' : 'Create'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
RegionForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default RegionForm;
